/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import ccTab from '@/components/common/tab/index.vue';
import pmxx from './pmxx/index.vue';
import pmfx from './pmfx/index.vue';
import kyxx from './kyxx/index.vue';

export default {
    name: 'kypm',
    components: {ccTab, pmxx, pmfx, kyxx},
    data() {
        return {
            tabList: [
                {
                    name: '拍卖信息',
                    code: 'pmxx'
                },
                {
                    name: '拍卖分析',
                    code: 'pmfx'
                },
                {
                    name: '扣押信息',
                    code: 'kyxx'
                }
            ],
            activeTab: 'pmxx',
            activePmlx:'cbpm',
            activeKylx:'cbky'
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'扣押拍卖',
                key:'kypm',
                path:'/kypm'
            }];
            const listItem = this.tabList.filter(item => item.code === this.activeTab)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.activeTab = this.$route.query.tab ? this.$route.query.tab : 'pmxx';
            if (this.$route.query.tab === 'pmxx') {
                this.activePmlx = window.localStorage.getItem(this.$route.query.tab);
            } else if (this.$route.query.tab === 'kyxx') {
                this.activeKylx = window.localStorage.getItem(this.$route.query.tab);
            }
        },
        // 切换拍卖类型
        changePmlx(code) {
            this.activePmlx = code;
        },
        // 切换筛选条件
        clickSearch(key, key01) {
            this.searchData[key] = key01;
        },
        // 点击跳转详情
        clickXq() {
            this.$router.push('/kypm/xq');
        },
        // 页签切换
        handelTabChange(code) {
            this.activeTab = code;
        }
    }
};

